import PageHeader from '../../utility/PageHeader';
import Table_example2 from '../../utility/form_example/Table_example2';
import React from 'react';
const Example2 = () => {
  return (
    <div>
      <PageHeader functionName={'menu-0-2'}></PageHeader>
      <div>
        <Table_example2 />
      </div>
    </div>
  );
};

export default Example2;
